
'use strict';

/**
 * Deferrals Utils
 *
 * Helper used to generate a new deferred object OR return an already existing one. This will ensure
 * that the same 'deferred' object is returned even if called multiple times. This is 
 * used in conjunction with debounced methods that return promises.
 */
var DeferralsUtil = function ($q) {

  var deferrals = {};

  this.get = function (id) {
    var deferred = deferrals[id];

    if (!deferrals[id]) {
      deferred = $q.defer();
      deferrals[id] = deferred;
    }

    return deferred;
  };

  this.clear = function (id) {
    deferrals[id] = null;
  };
};

module.exports = DeferralsUtil;


// WEBPACK FOOTER //
// ./src/common/utils/DeferralsUtil.js